/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_ContentInputs */



/**
* | output |
* | --- |
* | "Content Issue" |
*
* @param {Manual_Qc_Type_ContentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_content = /** @type {((inputs?: Manual_Qc_Type_ContentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_ContentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Probleme de contenu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhaltsproblem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problema di contenuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вопрос содержания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problema de contenido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("内容问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コンテンツの問題")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विषयवस्तु संबंधी समस्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Problema de conteúdo")
	return /** @type {LocalizedString} */ ("Content Issue")
});